<div class="area">
  <nz-collapse>
    <nz-collapse-panel [nzHeader]=" header" [nzActive]="opened" [nzExtra]="extra" (nzActiveChange)="opened = $event">
      <div customScroll [ngStyle]="{'max-height': maxHeight || '300px', 'overflow':'overlay'}">
        <ng-content></ng-content>
      </div>
    </nz-collapse-panel>
  </nz-collapse>
</div>
